import Handler from '@/language/handlers/Handler';
import Language from '@/language/Language';

export default abstract class AbstractHandler implements Handler {
    private nextHandler?: Handler;

    constructor(nextHandler?: Handler) {
        this.nextHandler = nextHandler;
    }

    public handle(language: Language): void {
        this.nextHandler?.handle(language);
    }
}
